/* eslint-disable prettier/prettier */
import React from 'react';
import { PurpleMenuItem, PurpleNotification, PurpleUser } from '../data/interfaces';

export interface PurpleContextType {
  navigation: PurpleMenuItem[];
  notifications: PurpleNotification[],
  user: PurpleUser | null,
  setMenu: (navigation: PurpleMenuItem[]) => void;
  setNotifications: (notifications: PurpleNotification[]) => void;
  addNotification: (notification: PurpleNotification) => void;
  setUser: (user: PurpleUser) => void;
}

const context = {
  navigation: [{ title: "test" }] as PurpleMenuItem[],
  notifications: [] as PurpleNotification[],
  user: null,
  setMenu: (navigation: PurpleMenuItem[]) => context.navigation = navigation,
  setNotifications: (notifications: PurpleNotification[]) => context.notifications = notifications,
  addNotification: (notification: PurpleNotification) => context.notifications.push(notification),
  setUser: (user: PurpleUser) => context.user = user
} as PurpleContextType

const PurpleContext = React.createContext<PurpleContextType>(context);

function usePurple() {
  return React.useContext(PurpleContext);
}

export { usePurple, PurpleContext };